import * as React from 'react';
import PropTypes from 'prop-types';
import {useTheme} from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import axios from "axios";
import {useState, useEffect} from 'react';
import {memo} from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {useAlert} from './useAlert';
import {
    styled
} from '@mui/material/styles';
import Avatar from "@mui/material/Avatar";
import status_off from "../assets/statusoff.svg"
import status_on from "../assets/statuson.svg"
import styles from '../css/ActorAnalyticsCard.module.css';


function getDaysInMonth(month, year) {
    const date = new Date(year, month, 0);
    const monthName = date.toLocaleDateString('en-US', {
        month: 'short',
    });
    const daysInMonth = date.getDate();
    const days = [];
    let i = 1;
    while (days.length < daysInMonth) {
        days.push(`${monthName} ${i}`);
        i += 1;
    }
    return days;
}

function AreaGradient({color, id}) {
    return (
        <defs>
            <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
                <stop offset="0%" stopColor={color} stopOpacity={0.3}/>
                <stop offset="100%" stopColor={color} stopOpacity={0}/>
            </linearGradient>
        </defs>
    );
}

function shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.value != this.state.value) {
        this.setState({value: nextProps.value});
        return true;
    }
    return false;
};

AreaGradient.propTypes = {
    color: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
};

function ActorAnalyticsCard(props) {
    const [datas, setData] = useState([]);
    const [xaxis, setXaxis] = useState([]);
    const [gauge_val, setGaugeValue] = useState(props.gauge_value);
    const showAlert = useAlert();
    var x = props.gauge_value;

    var xaxiss = [];
    if (props.gauge_value != undefined) {
        datas.push(props.gauge_value);
        xaxis.push(new Date());
    }


    const fetchData = async (measure, token) => {
        var data = []
        var yesterday = new Date();
        yesterday = new Date(yesterday.setDate(yesterday.getDate() - 1));
        var today = new Date();
        try {
            axios.post('/get_measures_by_timedelta/', {
                start_time: yesterday,
                end_time: today,
                grow_setup_id: props.grow_setup,
                aggregation_level: '5m',
                measure: measure,
            }, {
                withCredentials: true, // Include credentials in this request
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token,
                    'Method': 'GET',
                },
            }).then(response => {
                if(Object.keys(response.data).length) {
                    setData(response.data[0].data);
                    setXaxis(response.data[0].xaxis);
                }
            });


        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        //fetchData(props.measure, props.token);
    }, []);





    function click_actor_change(e) {
        fetch('/set_actor_mode', {
            'method': 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*', 'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({id: props.grow_setup, actor: props.measure, mode: e.target.value}),
            mode: 'cors'
        })
            .then(res => res.json())
            .then(
                (result) => {
                    showAlert('Actor Mode erfolgreich geändert', 'success');
                },
            )


    }

    return (<div>
        {props.issmall == 1 ?
            <Card variant="outlined" sx={{height: '100%', flexGrow: 1}}>
                <CardContent>
                    <div className={styles.aktorcard}>
                        <div className={gauge_val > 0 ? styles.frameTop : styles.frameTopRed}>
                            <div className={styles.name}>
                                <div className={styles.abluft}>{props.measure}</div>
                            </div>
                            {gauge_val > 0 ? <img alt="" src={status_on}/> : <img alt="" src={status_off}/>}
                        </div>
                        <div className={styles.frameMiddle}>
                            <div className={styles.frameAuto}>
                                <div className={styles.auto}>Auto</div>
                            </div>
                            <div className={styles.frameOn}>
                                <div className={styles.auto}>ON</div>
                            </div>
                            <div className={styles.frameOn}>
                                <div className={styles.auto}>OFF</div>
                            </div>
                        </div>
                        <div className={styles.frameTop1}>
                            <div className={styles.steuerartMesswerteSteuerzieContainer}>
                <span className={styles.steuerartMesswerteSteuerzieContainer1}>
                <p className={styles.steuerartMesswerte}>{props.text}</p>

</span>
                            </div>
                        </div>
                    </div>
                </CardContent></Card>
            :
            <div className={styles.aktorcard}>
                <div className={styles.frameTop}>
                    <div className={styles.name}>
                        <div className={styles.abluft}>Abluft</div>
                    </div>
                    <img className={styles.statusIcon} alt="" src="Status Icon.svg"/>
                </div>
                <div className={styles.frameMiddle}>
                    <div className={styles.frameAuto}>
                        <div className={styles.auto}>Auto</div>
                    </div>
                    <div className={styles.frameOn}>
                        <div className={styles.auto}>ON</div>
                    </div>
                    <div className={styles.frameOn}>
                        <div className={styles.auto}>OFF</div>
                    </div>
                </div>
                <div className={styles.frameTop1}>
                    <div className={styles.steuerartMesswerteSteuerzieContainer}>
                <span className={styles.steuerartMesswerteSteuerzieContainer1}>
                <p className={styles.steuerartMesswerte}>Steuerart: Messwerte</p>
                <p className={styles.steuerartMesswerte}>Steuerziel: Temp down</p>
                <p className={styles.steuerartMesswerte}>Sollwert: “Wert”</p>
                <p className={styles.steuerartMesswerte}>Sensor: Sensor BME</p>
</span>
                    </div>
                </div>
            </div>
        }

    </div>)
}

ActorAnalyticsCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.number).isRequired,
    interval: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    trend: PropTypes.oneOf(['down', 'neutral', 'up', 'blue', 'yellow', 'secondary', 'warning']).isRequired,
    value: PropTypes.string.isRequired,
    measure: PropTypes.string.isRequired
};

export default memo(ActorAnalyticsCard);
